import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { patchMe } from '../api/account';

interface AccountState {
  tempLocale: string | null;
  setLocale: (locale: string) => void;
  updateLocale: (locale: string) => Promise<void>;
}

export const useAccountStore = create<AccountState>()(
  persist(
    (set, get) => ({
      tempLocale: null,

      setLocale: (locale) => {
        set({ tempLocale: locale });
      },

      updateLocale: async (locale) => {
        try {
          await patchMe({ locale });
          get().setLocale(locale);
        } catch (error) {
          console.error('Failed to update locale:', error);
          throw error;
        }
      },
    }),
    {
      name: 'go-chat-app-storage',
    }
  )
);

export const useLocale = () => {
  const tempLocale = useAccountStore((state) => state.tempLocale);
  return tempLocale || 'ru';
};
